__webpack_require__.p = "/wp-content/themes/familytoday-twentynineteen/assets/app/dist/";